interface ArsenalButtonProps {
  title: string;
  description?: string;
  bg: string;
}

export function ArsenalHeader({ title, description, bg }: ArsenalButtonProps) {
  return (
    <div className="border-0 border-b border-secondary relative h-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          className="absolute inset-0 w-full h-full object-cover"
          src={`/img/backgrounds/${bg}`}
          alt={title}
        />
      </div>
      <div className="absolute inset-0 grid-overlay" />
      <div className="absolute inset-0 bg-linear-to-r from-black to-black/50" />

      <div className="absolute inset-0 flex justify-between items-center pr-2">
        <div className="p-2 text-left">
          <p className="text-xl font-bold">{title}</p>
          <p className="text-gray-300 text-sm">{description}</p>
        </div>
      </div>
    </div>
  );
}